"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.version = void 0;
var version = exports.version = "3.11.1";